module.exports = __webpack_public_path__ + "static/media/de-min.3ec591db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/de-min.svg
// module id = 699
// module chunks = 0